import(/* webpackMode: "eager", webpackExports: ["GenerateAssignmentSubPageView"] */ "/web/src/sections/sub-pages/lms/generate-assignment/view/generate-assignment-sub-page-view.tsx");
